// @core/api/endpoints/webhook/test_endpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestEndpointRequest,
  TestEndpointResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Send test webhook
 * Sends a test event to the webhook endpoint to verify connectivity and signature validation. Returns the delivery result immediately.
 */
export async function TestEndpoint(
  endpoint_id: string,
  data: TestEndpointRequest,
  options?: RequestOptions
): Promise<TestEndpointResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/endpoints/:endpoint_id/test`;
  requestPath = requestPath.replace(':endpoint_id', encodeURIComponent(endpoint_id));
  const requestOptions = options;
  return client.post<TestEndpointResponse>(requestPath, data, requestOptions);
}
